
<div class="modal-dialog nav-tabs-for-header-line" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Edit Asset</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body" *ngIf="loading">
      <error [error]="error"></error>
      <md-spinner-block></md-spinner-block>
    </div>
    <div class="modal-body" *ngIf="!loading">
      <error [error]="error"></error>
      <nav class="nav nav-tabs nav-fill mb-3"><a class="nav-item nav-link" href="javascript:void(0)" [ngClass]="{active: page === &quot;details&quot;}" (click)="page = &quot;details&quot;">Details</a><a class="nav-item nav-link" href="javascript:void(0)" [ngClass]="{active: page === &quot;dates&quot;}" (click)="page = &quot;dates&quot;">Dates</a></nav>
      <div [hidden]="page !== &quot;details&quot;">
        <form [formGroup]="asset.formGroup">
          <div class="row">
            <div class="form-group col-md-6">
              <label>Product Number:</label>
              <input class="form-control" type="text" name="productNumber" formControlName="productNumber" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Product Description:</label>
              <input class="form-control" type="text" name="modelName" formControlName="modelName" autoLinkToLabel>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Serial Number:</label>
              <input class="form-control" type="text" name="serialNumber" formControlName="serialNumber" autoLinkToLabel (input)="asset.formGroup.controls.serialNumber.setValue(asset.formGroup.controls.serialNumber.value.toUpperCase())">
            </div>
            <div class="form-group col-md-6">
              <label>Asset Tag:</label>
              <input class="form-control" type="text" name="assetTag" formControlName="assetTag" autoLinkToLabel>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Replacement Product Number:</label>
              <input class="form-control" type="text" name="replacementProductNumber" formControlName="replacementProductNumber" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Replacement Serial Number:</label>
              <input class="form-control" type="text" name="replacementProductSerial" formControlName="replacementProductSerial" autoLinkToLabel (input)="asset.formGroup.controls.replacementProductSerial.setValue(asset.formGroup.controls.replacementProductSerial.value.toUpperCase())">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label class="required">Disposition:</label>
              <select class="form-control" name="dispositionId" formControlName="dispositionId" autoLinkToLabel required>
                <option *ngFor="let disposition of asset.dispositions" [value]="disposition.id">{{ disposition.dispositionText }}</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label>Building:</label>
              <input class="form-control" type="text" name="building" formControlName="building" autoLinkToLabel>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Floor:</label>
              <input class="form-control" type="text" name="floor" formControlName="floor" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Floor Map ID:</label>
              <input class="form-control" type="text" name="floorMapId" formControlName="floorMapId" autoLinkToLabel>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Host Name:</label>
              <input class="form-control" type="text" name="hostName" formControlName="hostName" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>IP Address:</label>
              <input class="form-control" type="text" name="ipAddress" formControlName="ipAddress" autoLinkToLabel>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Department:</label>
              <input class="form-control" type="text" name="department" formControlName="department" autoLinkToLabel>
            </div>
            <div class="form-group col-md-6">
              <label>Case Number:</label>
              <input class="form-control" type="text" name="caseNumber" formControlName="caseNumber" autoLinkToLabel>
            </div>
          </div>
        </form>
      </div>
      <div [hidden]="page !== &quot;dates&quot;">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="datesTable">Dates</th>
              <th class="datesTable">Values</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="datesTable">
                <p class="p-datesTable">Remove Date:</p>
              </td>
              <td class="datesTable">
                <p class="p-datesTable" *ngIf="asset.installDate">{{ asset.installDate }}</p>
              </td>
            </tr>
            <tr>
              <td class="datesTable">
                <p class="p-datesTable">Original Installation Date:</p>
              </td>
              <td class="datesTable">
                <p class="p-datesTable" *ngIf="asset.originalInstallDate">{{ asset.originalInstallDate }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="save()">Save</button>
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Cancel</button>
    </div>
  </div>
</div>